import React, { useState } from "react";
import { AddNewRecipientDialog } from "./AddNewRecipientDialog";
import { AddNewRecipientAdminDialog } from "./AddNewRecipientAdminDialog";

export const AddNewRecipientFlow = ({ handleClose, refreshList }) => {
  const [recipientId, setRecipientId] = useState("");
  const [recipientName, setRecipientName] = useState("");

  return (
    <>
      <AddNewRecipientDialog
        open={!recipientId}
        handleClose={() => handleClose(false)}
        setRicipentId={setRecipientId}
        setRecipientName={setRecipientName}
      />
      <AddNewRecipientAdminDialog
        recipientId={recipientId}
        recipientName={recipientName}
        handleClose={() => handleClose(false)}
        refreshList={refreshList}
      />
    </>
  );
};
